import {Attachment} from "../../api/dtos/dtos";
import {UploadFile} from "antd/lib/upload/interface";

export function blobToBase64(file: Blob): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = error => reject(error);
  });
}

export const mapAttachmentToUploadFile = <T extends Attachment>(attachment: T): UploadFile<T> => {
  return {
    uid: `${attachment.id}`,
    name: attachment.name,
    url: attachment.url,
    response: attachment,
    status: 'done',
    size: 1,
    type: "",
  }
};


// WEBPACK FOOTER //
// ./src/common/input/image.ts